import type { Theme } from '@mui/material';

export const styles = {
  cell:
    (width = 'auto') =>
    (theme: Theme) => ({
      height: '1.25rem',
      py: 0,
      color: theme.colors.neutral[500],
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      maxWidth: width,
      width: width,
      px: 1,
      borderColor: theme.colors.neutral[100],

      '> *': {
        textOverflow: 'ellipsis',
        textWrap: 'nowrap',
        overflow: 'hidden',
      },
    }),

  surveyNameLink: (theme: Theme) => ({
    fontWeight: 500,

    '&:hover': {
      cursor: 'pointer',
      color: theme.colors.primary[700],
    },
  }),

  textButton: (theme: Theme) => ({
    fontWeight: 500,
    color: theme.colors.primary[700],
  }),

  favorite: (theme: Theme) => ({
    position: 'relative',
    width: '1.5rem',
    height: '1.5rem',

    '> svg': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '1.5rem',
      height: '1.5rem',

      '&:last-of-type': {
        fill: theme.colors.neutral[50],
      },
    },
  }),

  favoriteMarked: (theme: Theme) => ({
    fill: theme.colors.secondary[500],
  }),

  pill: (theme: Theme) => ({
    backgroundColor: theme.colors.neutral[50],
    color: theme.colors.neutral[600],
    fontWeight: 600,
    cursor: 'default',
    borderRadius: '1.75rem',
    px: 2,
    py: 0.5,
    display: 'inline-block',
  }),
};
